class QuickAddButton extends customElements.get('add-to-cart') {
  get miniCartEl() {
    return document.querySelector('mini-cart');
  }

  get quantity() {
    return parseInt(this.dataset.quantity, 10) || 1;
  }

  onClickHandler() {
    const variantId = this.dataset.variantId;
    if (!variantId) return;

    const quantity = this.quantity;

    if (document.body.classList.contains('template-cart') || !window.shopSettings.cartDrawer) {
      Shopify.postLink(window.routes.cart_add_url, {
        parameters: { id: variantId, quantity: quantity }
      });
      return;
    }

    this.setAttribute('disabled', true);
    this.classList.add('loading');

    const miniCart = this.miniCartEl;
    const sections = miniCart ? miniCart.getSectionsToRender().map((s) => s.id) : [];

    const body = JSON.stringify({
      id: variantId,
      quantity: quantity,
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(`${window.routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.status === 422) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
            detail: { errorMessage: parsedState.description }
          }));
        } else {
          miniCart && miniCart.renderContents(parsedState);
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: { product: parsedState }
          }));
        }
      })
      .catch((e) => console.error(e))
      .finally(() => {
        this.classList.remove('loading');
        this.removeAttribute('disabled');
      });
  }
}

if (!customElements.get('quick-add-button')) {
  customElements.define('quick-add-button', QuickAddButton);
}

class QuickAdd extends HTMLElement {
  connectedCallback() {
    if (this.__bound) return;
    this.__bound = true;

    this.button = this.querySelector('quick-add-button');

    this.addEventListener('click', (event) => {
      const option = event.target.closest('.card__quick-add-option');
      if (!option || option.disabled) return;

      event.preventDefault();
      event.stopPropagation();

      this.querySelectorAll('.card__quick-add-option').forEach((el) => {
        el.classList.remove('is-selected');
        el.setAttribute('aria-pressed', 'false');
      });

      option.classList.add('is-selected');
      option.setAttribute('aria-pressed', 'true');

      if (!this.button) return;

      if (option.dataset.variantId) {
        this.button.dataset.variantId = option.dataset.variantId;
        this.button.dataset.quantity = 1;
      } else {
        this.button.dataset.quantity = option.dataset.quantity;
      }
    });
  }
}

if (!customElements.get('quick-add')) {
  customElements.define('quick-add', QuickAdd);
}